import { axiosBeelineRequest } from '@beef/utils';
import { FPS_ENDPOINTS } from "../endpoints";
import { simpleGetRequest } from "../helpers";
export var fetchFpsData = simpleGetRequest(FPS_ENDPOINTS.fpsRequestInfo);
export var fetchFpsBinding = function fetchFpsBinding() {
  return axiosBeelineRequest({
    url: FPS_ENDPOINTS.fpsBinding
  });
};
export var fetchPsOperationDetails = function fetchPsOperationDetails(idPoint) {
  return axiosBeelineRequest({
    url: FPS_ENDPOINTS.psOperationDetails,
    params: {
      idPoint: idPoint
    }
  }).then(function (data) {
    return {
      payId: data.idPayment,
      qrCode: data.formUrl
    };
  });
};